import { BillCategory, BillCategoryNames } from '@fruitful/types';

/**
 * Bill category order for Money Mapper pills, picker, and “All” default sort.
 * “Other” is last so named categories appear first.
 */
export const BILL_CATEGORY_MEMBER_UI_ORDER: BillCategory[] = [
    BillCategory.LOANS,
    BillCategory.UTILITIES,
    BillCategory.SUBSCRIPTIONS,
    BillCategory.RENT_MORTGAGE,
    BillCategory.CHILDCARE,
    BillCategory.CREDIT_CARD_MINIMUM,
    BillCategory.INSURANCE,
    BillCategory.OTHER,
];

export const billCategoryDisplayName = (category: BillCategory): string =>
    BillCategoryNames[category];

export const parseBillCategory = (bill: {
    category?: string | null;
}): BillCategory => {
    const raw = bill.category;
    if (
        raw != null &&
        Object.values(BillCategory).includes(raw as BillCategory)
    ) {
        return raw as BillCategory;
    }
    return BillCategory.OTHER;
};
